import moment from 'moment';

export const defaultOptions = [
  {
    label: 'Past Hour',
    value: 'hour'
  },
  {
    label: 'Past 24 hours',
    value: 'day'
  },
  {
    label: 'Past Week',
    value: 'week'
  },
  {
    label: 'Past Month',
    value: 'month'
  }
];

export function getTimeRange(time) {
  let { span, from, to } = time;

  if (span) {
    const toDate = new Date(Date.now());
    const fromDate = getFromDate(span, toDate).toDate();

    to = toDate.toISOString();
    from = fromDate.toISOString();
  }

  return [from, to];
}

function getFromDate(span, date) {
  const mDate = moment(date);

  switch (span) {
    case 'hour':
      return mDate.subtract(1, 'hours');
    case 'day':
      return mDate.subtract(1, 'days');
    case 'week':
      return mDate.subtract(1, 'weeks');
    case 'month':
      return mDate.subtract(1, 'months');
    default:
      return mDate;
  }
}
